import { render, staticRenderFns } from "./PanelWithNotifyGroupEditor.vue?vue&type=template&id=62809525&lang=pug&"
import script from "./PanelWithNotifyGroupEditor.vue?vue&type=script&lang=ts&"
export * from "./PanelWithNotifyGroupEditor.vue?vue&type=script&lang=ts&"
import style0 from "./PanelWithNotifyGroupEditor.vue?vue&type=style&index=0&id=62809525&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports